/**
 * CLZ Search Side Panel v6
 * — Live predictive search, fixed image URLs
 */
(function () {
  'use strict';

  var PANEL_ID   = 'clz-search-sidepanel';
  var OVERLAY_ID = 'clz-search-overlay';
  var OPEN_CLASS = 'is-open';
  var debounceTimer;

  var SEARCH_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>';
  var CLOSE_SVG  = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path stroke-width="2.2" d="M6 18L18 6M6 6l12 12"/></svg>';

  /* ── Fix Shopify image URL ─────────────────────────────────── */
  function getSizedImageUrl(src, size) {
    if (!src) return null;
    // Already absolute
    if (src.indexOf('//') === 0) src = 'https:' + src;
    if (src.indexOf('http') === 0) {
      // Add size parameter using Shopify CDN pattern
      // e.g. image.jpg -> image_100x100.jpg
      return src.replace(/\.(jpg|jpeg|png|gif|webp)(\?.*)?$/i, function (match, ext, qs) {
        return '_' + size + 'x' + size + '.' + ext + (qs || '');
      });
    }
    return src;
  }

  /* ── Build panel once ─────────────────────────────────────── */
  function buildPanel() {
    if (document.getElementById(PANEL_ID)) return;

    var overlay = document.createElement('div');
    overlay.id = OVERLAY_ID;
    overlay.className = 'clz-search-overlay';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.addEventListener('click', closePanel);
    document.body.appendChild(overlay);

    var panel = document.createElement('div');
    panel.id = PANEL_ID;
    panel.className = 'clz-search-sidepanel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', 'Search');
    panel.tabIndex = -1;

    /* Header */
    var header = document.createElement('div');
    header.className = 'clz-search-sidepanel__header';

    var titleEl = document.createElement('p');
    titleEl.className = 'clz-search-sidepanel__title';
    titleEl.textContent = 'Search';

    var closeBtn = document.createElement('button');
    closeBtn.className = 'clz-search-sidepanel__close';
    closeBtn.setAttribute('aria-label', 'Close search');
    closeBtn.type = 'button';
    closeBtn.innerHTML = CLOSE_SVG;
    closeBtn.addEventListener('click', closePanel);

    header.appendChild(titleEl);
    header.appendChild(closeBtn);

    /* Body */
    var body = document.createElement('div');
    body.className = 'clz-search-sidepanel__body slim-scrollbar';

    /* Form + input */
    var form = document.createElement('form');
    form.action = '/search';
    form.method = 'get';
    form.setAttribute('role', 'search');

    var inputWrap = document.createElement('div');
    inputWrap.className = 'clz-search-sidepanel__input-wrap';

    var iconSpan = document.createElement('span');
    iconSpan.className = 'clz-search-sidepanel__search-icon';
    iconSpan.innerHTML = SEARCH_SVG;

    var input = document.createElement('input');
    input.type = 'text';
    input.name = 'q';
    input.id = 'clz-search-input';
    input.className = 'clz-search-input';
    input.placeholder = 'Search for...';
    input.setAttribute('aria-label', 'Search');
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('autocorrect', 'off');
    input.setAttribute('autocapitalize', 'off');
    input.setAttribute('spellcheck', 'false');
    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        fetchResults(input.value.trim());
      }, 280);
    });

    inputWrap.appendChild(iconSpan);
    inputWrap.appendChild(input);
    form.appendChild(inputWrap);
    body.appendChild(form);

    /* Results */
    var results = document.createElement('div');
    results.id = 'clz-search-results';
    results.className = 'clz-search-results';
    body.appendChild(results);

    /* Popular searches */
    var sugSource = document.querySelector('.drawer--search .search-drawer__suggestions');
    if (sugSource) {
      var divider = document.createElement('div');
      divider.className = 'clz-search-sidepanel__divider';
      divider.id = 'clz-popular-divider';
      divider.innerHTML = '<span>Popular searches</span>';
      body.appendChild(divider);
      var sugClone = sugSource.cloneNode(true);
      sugClone.id = 'clz-popular-suggestions';
      body.appendChild(sugClone);
    }

    panel.addEventListener('transitionend', function (e) {
      if (e.propertyName !== 'transform') return;
      if (!panel.classList.contains(OPEN_CLASS)) return;
      input.focus();
    });

    panel.appendChild(header);
    panel.appendChild(body);
    document.body.appendChild(panel);
  }

  /* ── Fetch ────────────────────────────────────────────────── */
  function fetchResults(query) {
    var resultsEl = document.getElementById('clz-search-results');
    var dividerEl = document.getElementById('clz-popular-divider');
    var popularEl = document.getElementById('clz-popular-suggestions');
    if (!resultsEl) return;

    if (!query || query.length < 2) {
      resultsEl.innerHTML = '';
      if (dividerEl) dividerEl.style.display = '';
      if (popularEl) popularEl.style.display = '';
      return;
    }

    if (dividerEl) dividerEl.style.display = 'none';
    if (popularEl) popularEl.style.display = 'none';
    resultsEl.innerHTML = '<div class="clz-search-loading"><span></span><span></span><span></span></div>';

    var url = '/search/suggest.json'
      + '?q=' + encodeURIComponent(query)
      + '&resources[type]=product'
      + '&resources[limit]=6'
      + '&resources[options][unavailable_products]=last'
      + '&resources[options][fields]=title,product_type,variants.title,vendor';

    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        renderResults(products, query);
      })
      .catch(function () {
        resultsEl.innerHTML = '<p class="clz-search-empty">Something went wrong. Please try again.</p>';
      });
  }

  /* ── Render ───────────────────────────────────────────────── */
  function renderResults(products, query) {
    var resultsEl = document.getElementById('clz-search-results');
    if (!resultsEl) return;

    if (!products.length) {
      resultsEl.innerHTML = '<p class="clz-search-empty">No results for &ldquo;' + escapeHtml(query) + '&rdquo;</p>';
      return;
    }

    var html = '<ul class="clz-search-results__list">';

    products.forEach(function (p) {
      /* Build a properly-sized Shopify CDN image URL */
      var imgHtml = '';
      if (p.featured_image && p.featured_image.url) {
        var imgUrl = getSizedImageUrl(p.featured_image.url, 128);
        imgHtml = '<img src="' + imgUrl + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="64" height="64">';
      } else if (typeof p.featured_image === 'string' && p.featured_image) {
        var imgUrl2 = getSizedImageUrl(p.featured_image, 128);
        imgHtml = '<img src="' + imgUrl2 + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="64" height="64">';
      } else {
        imgHtml = '<div class="clz-search-results__img-placeholder"></div>';
      }

      /* Price — API returns price as string like "29.99" or in cents as number */
      var price = '';
      if (p.price !== undefined && p.price !== null) {
        price = formatMoney(p.price);
      }
      var comparePrice = '';
      if (p.compare_at_price_min && p.compare_at_price_min > p.price) {
        comparePrice = '<s class="clz-search-results__compare-price">' + formatMoney(p.compare_at_price_min) + '</s>';
      }

      html += '<li class="clz-search-results__item">';
      html += '<a href="' + p.url + '" class="clz-search-results__link">';
      html += '<div class="clz-search-results__img">' + imgHtml + '</div>';
      html += '<div class="clz-search-results__info">';
      html += '<span class="clz-search-results__title">' + escapeHtml(p.title) + '</span>';
      if (p.vendor) html += '<span class="clz-search-results__vendor">' + escapeHtml(p.vendor) + '</span>';
      if (price) html += '<span class="clz-search-results__price">' + price + comparePrice + '</span>';
      html += '</div></a></li>';
    });

    html += '</ul>';
    html += '<a href="/search?q=' + encodeURIComponent(query) + '&type=product" class="clz-search-results__view-all">View all results &rarr;</a>';

    resultsEl.innerHTML = html;
  }

  /* ── Helpers ──────────────────────────────────────────────── */
  function formatMoney(value) {
    /* Shopify suggest API returns price as a decimal string e.g. "29.99" */
    var num = parseFloat(String(value).replace(/[^0-9.]/g, ''));
    if (isNaN(num)) return '';
    /* If value looks like cents (very large number), divide */
    if (num > 1000 && String(value).indexOf('.') === -1) num = num / 100;
    /* Use shop money format if available */
    var fmt = (window.theme && window.theme.settings && window.theme.settings.money_format) || '';
    if (fmt) {
      return fmt.replace('{{amount}}', num.toFixed(2))
               .replace('{{amount_no_decimals}}', Math.round(num))
               .replace('{{amount_with_comma_separator}}', num.toFixed(2).replace('.', ','));
    }
    return '$' + num.toFixed(2);
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ── Open / Close ─────────────────────────────────────────── */
  function openPanel() {
    buildPanel();
    var panel   = document.getElementById(PANEL_ID);
    var overlay = document.getElementById(OVERLAY_ID);
    overlay.classList.add(OPEN_CLASS);
    panel.classList.add(OPEN_CLASS);
    document.documentElement.style.overflow = 'hidden';
    panel.focus();
    document.addEventListener('keydown', handleEsc);
  }

  function closePanel() {
    var panel   = document.getElementById(PANEL_ID);
    var overlay = document.getElementById(OVERLAY_ID);
    if (!panel || !overlay) return;
    overlay.classList.remove(OPEN_CLASS);
    panel.classList.remove(OPEN_CLASS);
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', handleEsc);
    var trigger = document.querySelector('.clz-search-trigger');
    if (trigger) trigger.focus();
  }

  function handleEsc(e) {
    if (e.key === 'Escape' || e.key === 'Esc') closePanel();
  }

  function bindTriggers() {
    document.querySelectorAll('.clz-search-trigger').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation(); openPanel();
      });
    });
    document.querySelectorAll('.drawer--search .drawer__button').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var details = btn.closest('details');
        if (details && details.open) details.open = false;
        openPanel();
      });
    });
  }

  function init() { bindTriggers(); buildPanel(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
